import { render, staticRenderFns } from "./will-writing-advice-wills.vue?vue&type=template&id=06611430"
import script from "./will-writing-advice-wills.vue?vue&type=script&lang=ts"
export * from "./will-writing-advice-wills.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports